"use client";

import { Col } from "react-bootstrap";
import Link from "next/link";
import { useSearchParams } from "next/navigation";

type Props = { poll: PollData };

export function ButtonPoll(props: Props) {
  const searchParams = useSearchParams();
  const isGuardian = searchParams.get("opiekun");
  const userId = searchParams.get("userId");

  const href = `/${props.poll.mainRoute}/${props.poll.route}${isGuardian === "true" ? "?opiekun=true" : ""}${userId ? `&userId=${userId}` : ""}`;

  return (
    <Col
      xs={12}
      md={6}
      lg={4}
      className="d-flex justify-content-center align-items-center"
    >
      <Link
        href={href}
        className="border border-2 rounded p-0 h5 h-100 w-100 d-flex justify-content-center align-items-center text-decoration-none text-body"
      >
        <div className="p-3 w-100 text-start">{props.poll.title}</div>
      </Link>
    </Col>
  );
}
